import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Image, Badge } from 'react-bootstrap';
import { getImageProduit } from 'data/produits';
import PropTypes from 'prop-types';
import ImageProduit from 'assets/img/products/product-placeholder11.png';

const EnteteDetails = ({ produit }) => {
  const [image, setImage] = useState(ImageProduit);

  useEffect(() => {
    const fetchImage = async () => {
      try {
        console.log('Fetching image...');
        const imageUrl = await getImageProduit(produit.imagePath);
        setImage(imageUrl);
      } catch (error) {
        console.error('Error fetching image:', error);
      }
    };
    fetchImage();
  }, [produit.imagePath]);

  return (
    <Card style={{ height: '300px' }}>
      <Card.Body>
        <Row>
          <Col md="auto">
            <div
              style={{
                height: '210px',
                width: '210px',
                border: '1px dotted rgb(64, 72, 80)'
              }}
            >
              <Image
                src={image}
                style={{ height: '200px', width: '200px' }}
                className="rounded"
              />
            </div>
          </Col>
          <Col>
            <div className="d-flex align-items-start">
              <h3 className="fw-bold d-inline">{produit.produit}</h3>{' '}
              <Badge bg="primary" className="ms-2 fs-10">
                {produit.typeProduit}
              </Badge>
            </div>
            <Row>
              <div className="d-flex gap-3 fw-bold">
                <div className="text-primary">
                  Marque :
                  <span className="text-black ms-2">
                    {produit.marque || 'Non renseigné'}
                  </span>
                </div>
                <div className="text-primary">
                  Catégorie :
                  <span className="text-black  ms-2">
                    {produit.categorie || 'Non renseigné'}
                  </span>
                </div>
              </div>
            </Row>
            <Row className="mt-3">
              <div className="d-flex gap-3 fw-bold">
                <div
                  className="d-flex flex-column p-2 mt-2"
                  style={{ border: '1px dotted rgb(205, 219, 233)' }}
                >
                  <p>{produit.id}</p>
                  <span className="text-primary">ID Produit</span>
                </div>
                <div
                  className="d-flex flex-column p-2 mt-2"
                  style={{ border: '1px dotted rgb(205, 219, 233)' }}
                >
                  <p>{`${produit.prixHt && produit.prixHt.toFixed(3)} DT`}</p>
                  <span className="text-primary">Prix HT</span>
                </div>
                <div
                  className="d-flex flex-column p-2 mt-2 pe-4 align-items-start"
                  style={{ border: '1px dotted rgb(205, 219, 233)' }}
                >
                  <p>{`${produit.tva && produit.tva} %`}</p>
                  <span className="text-primary">TVA</span>
                </div>
                <div
                  className="d-flex flex-column p-2 mt-2"
                  style={{ border: '1px dotted rgb(205, 219, 233)' }}
                >
                  <p>{`${produit.prixTtc && produit.prixTtc.toFixed(3)} DT`}</p>
                  <span className="text-primary">Prix TTC</span>
                </div>
              </div>
            </Row>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

EnteteDetails.propTypes = {
  produit: PropTypes.object.isRequired
};

export default EnteteDetails;
